// Нижнее окно («шторка») и готовые окна: выбор из списка, ввод значения, валюта, строки карточек.
import { normSig } from '@praktika/core';
import { $, $$, esc } from './dom.ts';
import { histBack, pushHistory, setSheetCloser } from './nav.ts';

export function openSheet(html: string): HTMLElement {
  const s = $('#sheet');
  s.hidden = false;
  s.innerHTML = '<div class="dim"></div><div class="bsheet"><div class="grab"></div>' + html + '</div>';
  $('.dim', s).onclick = () => closeSheet();
  document.body.style.overflow = 'hidden';
  if (!(history.state && (history.state as { sheet?: boolean }).sheet)) pushHistory(true);
  return $('.bsheet', s);
}

export function closeSheet(fromHistory = false): void {
  const s = $('#sheet');
  if (s.hidden) return;
  s.hidden = true;
  s.innerHTML = '';
  document.body.style.overflow = '';
  if (!fromHistory && history.state && (history.state as { sheet?: boolean }).sheet) histBack();
}
setSheetCloser(closeSheet);

export function opt(cls: string, icon: string, label: string, hint?: string): string {
  return '<button class="opt ' + (cls || '') + '">' + (icon || '') + '<span>' + esc(label) + '</span>' +
    (hint ? '<span class="hint">' + esc(hint) + '</span>' : '') + '</button>';
}

export const IC = {
  ok: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
  warn: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>',
  x: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8 8l8 8M16 8l-8 8"/></svg>',
  cal: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>',
  chat: '<svg viewBox="0 0 24 24"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-5A8 8 0 1 1 21 12z"/></svg>',
  edit: '<svg viewBox="0 0 24 24"><path d="M4 20h4l10-10-4-4L4 16v4z"/><path d="M12 8l4 4"/></svg>',
  card: '<svg viewBox="0 0 24 24"><rect x="3" y="7" width="18" height="12" rx="2"/><path d="M3 11h18"/></svg>',
  video: '<svg viewBox="0 0 24 24"><rect x="3" y="6" width="13" height="12" rx="2"/><path d="M16 10l5-3v10l-5-3"/></svg>',
  trash: '<svg viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
  psy: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>',
};

export type PromptType = 'text' | 'number' | 'textarea' | 'url' | 'date' | 'time' | 'tel' | 'email';

// Ввод одного значения. Для чисел — строка с точкой вместо запятой (пусто — '').
export function promptSheet(label: string, value: unknown, type: PromptType, cb: (v: string) => void, hint?: string): void {
  const area = type === 'textarea';
  const sh = openSheet('<div class="ttl">' + esc(label) + '</div>' + (hint ? '<p class="sub">' + esc(hint) + '</p>' : '') +
    '<div class="field" style="margin:8px 0 12px"><' + (area ? 'textarea' : 'input type="' + (type || 'text') +
    '" inputmode="' + (type === 'number' ? 'decimal' : 'text') + '"') + ' data-v>' + (area ? esc(value) + '</textarea>' :
    '') + '</div><div class="btnrow" style="padding:0"><button class="btn pri" data-ok>Готово</button></div>');
  const inp = $<HTMLInputElement>('[data-v]', sh);
  if (!area) inp.value = value === null || value === undefined ? '' : String(value);
  $('[data-ok]', sh).onclick = () => {
    const v = inp.value;
    closeSheet();
    cb(type === 'number' ? (v === '' ? '' : String(v).replace(',', '.')) : v);
  };
  inp.onkeydown = (e) => { if (e.key === 'Enter' && !area) $('[data-ok]', sh).click(); };
  setTimeout(() => inp.focus(), 50);
}

export interface Choice<T = string> { value: T; label: string; hint?: string }

export function chooseSheet<T>(label: string, options: Array<Choice<T>>, current: T, cb: (v: T) => void): void {
  const sh = openSheet('<div class="ttl">' + esc(label) + '</div>' +
    options.map((o) => opt(o.value === current ? 'ok' : '', '', o.label, o.hint)).join(''));
  $$('button.opt', sh).forEach((x, i) => { x.onclick = () => { closeSheet(); cb(options[i]!.value); }; });
}

export const CUR_LIST = ['AMD', 'EUR', 'RUB', 'USD', 'GEL', 'GBP'];
export function curOptions(list = CUR_LIST): Array<Choice> { return list.map((x) => ({ value: x, label: x })); }
export function curSheet(label: string, current: string, cb: (v: string) => void): void {
  chooseSheet(label || 'Валюта', curOptions(), current, cb);
}

// поиск по списку в окне: скрывает строки, где нет набранного
export function bindSearch(q: HTMLInputElement, root: ParentNode): void {
  q.oninput = () => {
    const v = normSig(q.value);
    $$('.pick .opt', root).forEach((o) => { o.style.display = !v || normSig(o.textContent).includes(v) ? '' : 'none'; });
  };
}

// строка карточки: подпись слева, значение справа со стрелкой
export function kvBtn(k: string, v: unknown, attr: string, cls?: string): string {
  return '<button class="kv' + (cls ? ' ' + cls : '') + '" ' + attr + '><span class="k">' + esc(k) +
    '</span><span class="v chev">' + (v === '' || v === null || v === undefined ?
    '<span style="color:#9aa4b8;font-weight:400">не задано</span>' : esc(v)) + '</span></button>';
}

export function kvTog(k: string, on: boolean, attr: string): string {
  return '<button class="kv" ' + attr + '><span class="k">' + esc(k) + '</span><span class="tog' + (on ? ' on' : '') +
    '"></span></button>';
}
